import type { DinosaurSpecies } from '../../state/game-state';

export type SpeciesConfig = {
  speed: number;
  spawnWeight: number;
  corruptionOnReach: number;
  scaleRange: [number, number];
  bodyColor: number;
  headColor: number;
  emissive: number;
  emissiveIntensity: number;
  heightMul: number;
  gait: 'bipedal' | 'quadruped';
  silhouette: 'raptor' | 'large' | 'frilled' | 'sail' | 'small' | 'armored';
  armored: boolean;
};

export const SPECIES_CONFIG: Record<DinosaurSpecies, SpeciesConfig> = {
  raptor: {
    speed: 3.5,
    spawnWeight: 5,
    corruptionOnReach: 5,
    scaleRange: [1.7, 2.0],
    bodyColor: 0xa8d850,
    headColor: 0xc8e060,
    emissive: 0x4a7820,
    emissiveIntensity: 0.25,
    heightMul: 1.0,
    gait: 'bipedal',
    silhouette: 'raptor',
    armored: false,
  },
  trex: {
    speed: 1.8,
    spawnWeight: 0.5,
    corruptionOnReach: 20,
    scaleRange: [2.2, 2.8],
    bodyColor: 0xd09a4a,
    headColor: 0xe8b860,
    emissive: 0x6a4820,
    emissiveIntensity: 0.2,
    heightMul: 1.6,
    gait: 'bipedal',
    silhouette: 'large',
    armored: false,
  },
  dilophosaurus: {
    speed: 2.5,
    spawnWeight: 3,
    corruptionOnReach: 8,
    scaleRange: [1.5, 1.8],
    bodyColor: 0x6ad84a,
    headColor: 0xffcc00,
    emissive: 0x307820,
    emissiveIntensity: 0.3,
    heightMul: 1.0,
    gait: 'bipedal',
    silhouette: 'frilled',
    armored: false,
  },
  spinosaurus: {
    speed: 1.5,
    spawnWeight: 1,
    corruptionOnReach: 15,
    scaleRange: [2.2, 2.8],
    bodyColor: 0xb0b85a,
    headColor: 0xd0d070,
    emissive: 0x504820,
    emissiveIntensity: 0.2,
    heightMul: 1.5,
    gait: 'bipedal',
    silhouette: 'sail',
    armored: false,
  },
  compsognathus: {
    speed: 5.0,
    spawnWeight: 4,
    corruptionOnReach: 3,
    scaleRange: [0.9, 1.1],
    bodyColor: 0xe8d850,
    headColor: 0xfff080,
    emissive: 0x806820,
    emissiveIntensity: 0.3,
    heightMul: 0.5,
    gait: 'bipedal',
    silhouette: 'small',
    armored: false,
  },
  ankylosaurus: {
    speed: 1.2,
    spawnWeight: 2.5,
    corruptionOnReach: 10,
    scaleRange: [1.7, 2.0],
    bodyColor: 0x6a7a90,
    headColor: 0x8a9ab0,
    emissive: 0x303a40,
    emissiveIntensity: 0.35,
    heightMul: 0.85,
    gait: 'quadruped',
    silhouette: 'armored',
    armored: true,
  },
};

export const SPECIES_LIST: DinosaurSpecies[] = [
  'raptor',
  'dilophosaurus',
  'compsognathus',
  'ankylosaurus',
  'spinosaurus',
  'trex',
];
